import {
  STRIPE_CREATE_SESSION_REQUEST,
  STRIPE_CREATE_SESSION_SUCCESS,
  STRIPE_CREATE_SESSION_FAILURE,
  STRIPE_PAYMENT_SUCCESS,
  STRIPE_PAYMENT_FAILURE,
  StripeState,
  StripeActionTypes,
} from "../types/stripeTypes";

const initialState: StripeState = {
  status: false,
  success: false,
  sessionId: null,
  paymentDetails: null,
  loading: false,
  error: null,
};

export const stripeReducer = (
  state = initialState,
  action: StripeActionTypes
): StripeState => {
  switch (action.type) {
    case STRIPE_CREATE_SESSION_REQUEST:
      return { ...state, loading: true, error: null };

    case STRIPE_CREATE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionId: action.payload?.sessionId,
      };

    case STRIPE_CREATE_SESSION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case STRIPE_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        status: action.payload?.success,
        paymentDetails: action.payload?.data?.payment,
      };

    case STRIPE_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
